let emjoytab = [
    { id: 0, name: 'role', src: "https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/cover.png" },
    { id: 1, name: 'dragon', src: "https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/cover.png" },
    { id: 2, name: 'littleDragon', src: "https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/cover.png" },
]
let dqssEmjoytab = [
    { id: 0, name: 'role', src: "https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/cover.png" },
]
let glEmjoytab = [
    { id: 0, name: 'role', src: "https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/cover.png" },
]
let emjoylist = [
    {
        id: 0, name: 'role', list: [
            {
                id: 0,
                name: '赞',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/01.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/01.gif'
            },
            {
                id: 1,
                name: '唉',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/02.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/02.gif'
            },
            {
                id: 2,
                name: '哭',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/03.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/03.gif'
            },
            {
                id: 3,
                name: '心碎',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/04.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/04.gif'
            },
            {
                id: 4,
                name: '会好的',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/05.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/05.gif'
            },
            {
                id: 5,
                name: '你好',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/06.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/06.gif'
            },
            {
                id: 6,
                name: '穷',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/07.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/07.gif'
            },
            {
                id: 7,
                name: '对不起',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/08.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/08.gif'
            },
            {
                id: 8,
                name: '哇',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/09.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/09.gif'
            },
            {
                id: 9,
                name: '贴贴',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/10.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/10.gif'
            },
            {
                id: 10,
                name: '得意',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/11.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/11.gif'
            },
            {
                id: 11,
                name: '冲',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/12.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/12.gif'
            },
            {
                id: 12,
                name: '好的',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/13.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/13.gif'
            },
            {
                id: 13,
                name: '赏点吧',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/14.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/14.gif'
            },
            {
                id: 14,
                name: '谢谢',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/15.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/15.gif'
            },
            {
                id: 15,
                name: '累',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/16.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/role/16.gif'
            },
        ]
    },
    {
        id: 1, name: 'dragon', list: [
            {
                id: 0,
                name: '什么',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/01.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/01.gif'
            },
            {
                id: 1,
                name: '好',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/02.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/02.gif'
            },
            {
                id: 2,
                name: '不',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/03.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/03.gif'
            },
            {
                id: 3,
                name: '困',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/04.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/04.gif'
            },
            {
                id: 4,
                name: '饿',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/05.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/05.gif'
            },
            {
                id: 5,
                name: '好吃',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/06.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/06.gif'
            },
            {
                id: 6,
                name: '睡觉',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/07.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/07.gif'
            },
            {
                id: 7,
                name: '不单纯',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/08.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/08.gif'
            },
            {
                id: 8,
                name: '唉',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/09.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/09.gif'
            },
            {
                id: 9,
                name: '惊',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/10.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/10.gif'
            },
            {
                id: 10,
                name: '生气',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/11.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/11.gif'
            },
            {
                id: 11,
                name: '无语',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/12.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/12.gif'
            },
            {
                id: 12,
                name: '累',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/13.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/13.gif'
            },
            {
                id: 13,
                name: '爱你',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/14.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/14.gif'
            },
            {
                id: 14,
                name: '你说',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/15.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/15.gif'
            },
            {
                id: 15,
                name: '加油',
                class: '大王龙',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/16.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dragon/16.gif'
            },
        ]
    },
    {
        id: 2, name: 'littleDragon', list: [
            {
                id: 0,
                name: '可怜',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/01.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/01.gif'
            },
            {
                id: 1,
                name: '无语',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/02.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/02.gif'
            },
            {
                id: 2,
                name: '自闭',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/03.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/03.gif'
            },
            {
                id: 3,
                name: '冲呀',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/04.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/04.gif'
            },
            {
                id: 4,
                name: '开心',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/05.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/05.gif'
            },
            {
                id: 5,
                name: '生气',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/06.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/06.gif'
            },
            {
                id: 6,
                name: '爱心',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/07.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/07.gif'
            },
            {
                id: 7,
                name: '嘿嘿',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/08.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/08.gif'
            },
            {
                id: 8,
                name: '拜拜',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/09.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/09.gif'
            },
            {
                id: 9,
                name: '在吗',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/10.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/10.gif'
            },
            {
                id: 10,
                name: '惊吓',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/11.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/11.gif'
            },
            {
                id: 11,
                name: '哈哈',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/12.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/12.gif'
            },
            {
                id: 12,
                name: '拜托',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/13.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/13.gif'
            },
            {
                id: 13,
                name: '怒',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/14.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/14.gif'
            },
            {
                id: 14,
                name: '得意',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/15.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/15.gif'
            },
            {
                id: 15,
                name: '心动',
                class: '哈尔',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/16.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/littleDragon/16.gif'
            },
        ]
    }

]

let dqssEmjoylist = [
    {
        id: 0, name: 'role', list: [
            {
                id: 0,
                name: '大笑',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/01.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/01.png'
            },
            {
                id: 1,
                name: '微笑',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/02.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/02.png'
            },
            {
                id: 2,
                name: '努力',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/03.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/03.png'
            },
            {
                id: 3,
                name: '生气',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/04.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/04.png'
            },
            {
                id: 4,
                name: '点赞',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/05.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/05.png'
            },
            {
                id: 5,
                name: '吐舌',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/06.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/06.png'
            },
            {
                id: 6,
                name: '刀你',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/07.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/07.png'
            },
            {
                id: 7,
                name: '疑问',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/08.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/08.png'
            },
            {
                id: 8,
                name: '惊慌',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/09.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/09.png'
            },
            {
                id: 9,
                name: '大哭',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/10.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/10.png'
            },
            {
                id: 10,
                name: '思考',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/11.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/11.png'
            },
            {
                id: 11,
                name: '难过',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/12.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/12.png'
            },
            {
                id: 12,
                name: '加油',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/13.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/13.png'
            },
            {
                id: 13,
                name: '震惊',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/14.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/14.png'
            },
            {
                id: 14,
                name: '笔芯',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/15.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/15.png'
            },
            {
                id: 15,
                name: '害羞',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/16.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/16.png'
            },
            {
                id: 16,
                name: '拉手',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/17.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/17.png'
            },
            {
                id: 17,
                name: '不屑',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/18.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/18.png'
            },
            {
                id: 18,
                name: '挑衅',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/19.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/19.png'
            },
            {
                id: 19,
                name: '你好',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/20.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/dqss/role/20.png'
            },
        ]
    }
]
let glEmjoylist = [
    {
        id: 0, name: 'role', list: [
            {
                id: 0,
                name: '耶',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/1.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/1.png'
            },
            {
                id: 1,
                name: '睿智',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/2.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/2.png'
            },
            {
                id: 2,
                name: '累了',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/3.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/3.png'
            },
            {
                id: 3,
                name: '谢谢老板',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/4.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/4.png'
            },
            {
                id: 4,
                name: '晚安',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/5.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/5.png'
            },
            {
                id: 5,
                name: '哼',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/6.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/6.png'
            },
            {
                id: 6,
                name: '管好自己',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/7.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/7.png'
            },
            {
                id: 7,
                name: '差不多得了',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/8.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/8.png'
            },
            {
                id: 8,
                name: '没有欲望',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/9.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/9.png'
            },
            {
                id: 9,
                name: '满头问号',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/10.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/10.png'
            },
            {
                id: 10,
                name: '暗中观察',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/11.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/11.png'
            },
            {
                id: 11,
                name: '我哭了我装的',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/12.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/12.png'
            },
            {
                id: 12,
                name: '害羞',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/13.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/13.png'
            },
            {
                id: 13,
                name: '嘤嘤嘤',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/14.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/14.png'
            },
            {
                id: 14,
                name: '谢谢',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/15.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/15.png'
            },
            {
                id: 15,
                name: '重拳出击',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/16.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/16.png'
            },
            {
                id: 16,
                name: '夺笋啊',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/17.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/17.png'
            },
            {
                id: 17,
                name: '生气',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/18.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/18.png'
            },
            {
                id: 18,
                name: '使不得',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/19.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/19.png'
            },
            {
                id: 19,
                name: '修理谁',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/20.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/20.png'
            },
            {
                id: 20,
                name: '冲鸭',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/21.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/21.png'
            },
            {
                id: 21,
                name: '开工',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/22.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/22.png'
            },
            {
                id: 22,
                name: '你过来呀',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/23.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/23.png'
            },
            {
                id: 23,
                name: '好点子',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/24.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/24.png'
            },
            {
                id: 24,
                name: '我来啦',
                class: '角色',
                src: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/25.png',
                gifSrc: 'https://media.zlongame.com/media/pictures/cn/community/img/emjoy/gl/role/25.png'
            },
        ]
    }
]


export default {
    emjoytab,
    emjoylist,
    dqssEmjoytab,
    dqssEmjoylist,
    glEmjoytab,
    glEmjoylist
}